import Vue from "vue";
import { filter } from "lodash";
const Vue2TouchEvents = require('vue2-touch-events');
var swipeIcon = require("@/assets/svgs/swipe-right.svg");
var ScrollMagic = require('ScrollMagic');
Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    swipeTolerance: 30,
    longTapTimeInterval: 400
});
export default Vue.extend({
    name: 'image-slideshow',
    components: {
        'swipe-icon': swipeIcon,
    },
    data() {
        return {
            slides: [],
            active: 0,
            iconIsAnimate: false
        };
    },
    mounted() {
        this.slides = filter(this.$slots.default, { tag: 'div' });
        if (window.innerWidth <= 1023) {
            setInterval(() => {
                this.nextSlide();
            }, 4000);
        }
    },
    methods: {
        removeIcon() {
            let $swipeIcon = document.querySelector('.swipe-icon');
            $swipeIcon.classList.add('hidden');
        },
        nextSlide() {
            this.active += 1;
            if (this.active > this.slides.length - 1) {
                this.active = 0;
            }
        },
        prevSlide() {
            this.active -= 1;
            if (this.active == -1) {
                this.active = this.slides.length - 1;
            }
        },
    },
    computed: {
        activeSlide() {
            return this.active;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/image-slideshow/image-slideshow.ts
// module id = null
// module chunks = 